// Get the current environment
const isDevelopment = import.meta.env.DEV;

// Use localhost in development, production Pages URL otherwise
export const CHAT_API_BASE = isDevelopment 
  ? 'http://localhost:8788'  // Chat worker
  : 'https://flows-chat.enginable.com';

// Use Pages Functions for tree operations
export const TREES_API_BASE = isDevelopment
  ? 'http://localhost:8787'  // Tree API
  : 'https://flows.enginable.com';
